import { connect } from 'react-redux';
import GlobalListings from '../components/global-listings/index';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    defaultOptions: state.store.defaultOptions
  };
};

export default connect(mapStateToProps)(GlobalListings);


// WEBPACK FOOTER //
// ./src/containers/global-listings.js